import type React from "react";
import { useState, useCallback, useMemo } from "react";

import { useGeoLocation, type GeoLocation } from "../hooks/useGeoLocation";

import { SearchRankingContext, type SortMode } from "./context";

type SearchRankingProviderProps = {
  children: React.ReactNode;
};

export const SearchRankingProvider: React.FC<SearchRankingProviderProps> = ({ children }) => {
  const [sortMode, setSortMode] = useState<SortMode>("relevance");
  const [userLocation, setUserLocation] = useState<GeoLocation | null>(null);
  const [locationDenied, setLocationDenied] = useState(false);
  const geoLocation = useGeoLocation();

  const requestLocation = useCallback(async (): Promise<GeoLocation> => {
    try {
      const location = await geoLocation.requestLocation();
      setUserLocation(location);
      setLocationDenied(false);
      return location;
    } catch {
      setLocationDenied(true);
      throw new Error("Location denied");
    }
  }, [geoLocation]);

  const value = useMemo(
    () => ({
      sortMode,
      userLocation,
      locationDenied,
      setSortMode,
      requestLocation,
    }),
    [sortMode, userLocation, locationDenied, requestLocation],
  );

  return <SearchRankingContext.Provider value={value}>{children}</SearchRankingContext.Provider>;
};
